import React, { useState } from "react";
import { useParams } from "react-router-dom";
import SettingsSidebar from "./SettingsSidebar";
import AccountSettings from "./account/AccountSettings";
import SubscriptionSettings from "./subscription/SubscriptionSettings";
import PreferencesSettings from "./preferences/PreferencesSettings";
import NotificationsSettings from "./notifications/NotificationsSettings";
import { Container } from "../../../design-system";
import { typography, surfaces, borders, textColors } from "../../../design-system/tokens";

const Settings = () => {
  const { username, section } = useParams();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const renderSettingsSection = () => {
    switch (section) {
      case "account":
        return <AccountSettings username={username} />;
      case "subscription":
        return <SubscriptionSettings username={username} />;
      case "preferences":
        return <PreferencesSettings username={username} />;
      case "notifications":
        return <NotificationsSettings username={username} />;
      default:
        return <AccountSettings username={username} />;
    }
  };

  const getSectionTitle = () => {
    switch (section) {
      case "account":
        return "Account Settings";
      case "subscription":
        return "Subscription";
      case "preferences":
        return "Preferences";
      case "notifications":
        return "Notifications";
      default:
        return "Account Settings";
    }
  };

  return (
    <div className={`min-h-screen flex overflow-x-hidden ${surfaces.modernApp} transition-colors duration-300`}>
      {/* Sidebar */}
      <SettingsSidebar
        username={username}
        isOpen={sidebarOpen}
        toggleSidebar={toggleSidebar}
      />

      {/* Main Content */}
      <div className="flex-1 min-w-0 lg:ml-0">
        {/* Mobile Header */}
        <div className={`lg:hidden px-4 py-3 ${surfaces.glass} border-b ${borders.glass}`}>
          <div className="flex items-center justify-between">
            <h1 className={`${typography.h4} ${textColors.primary}`}>
              {getSectionTitle()}
            </h1>
            <button
              onClick={toggleSidebar}
              className={`p-2 rounded-md transition-colors ${textColors.secondary} ${surfaces.hover}`}
              aria-label="Open settings menu"
            >
              <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
              </svg>
            </button>
          </div>
        </div>

        {/* Desktop Header */}
        <div className={`hidden lg:block px-8 py-6 ${surfaces.glass} border-b ${borders.glass}`}>
          <h1 className={`${typography.h3} ${textColors.primary}`}>
            {getSectionTitle()}
          </h1>
        </div>

        {/* Content Area */}
        <Container size="7xl" className="p-4 lg:p-8">
          {renderSettingsSection()}
        </Container>
      </div>
    </div>
  );
};

export default Settings; 